import { EMPLOYEE_SHORTCUTS, USER_ROLES } from 'shared/consts';

const mapRoleToShortcut = role => EMPLOYEE_SHORTCUTS[Object.keys(USER_ROLES).find(key => USER_ROLES[key] === role)];

export default mapRoleToShortcut;
